import request from "helpers/api_helper";
import { toast } from "react-toastify";

// Get all locations
export const getLocations = async (queryString?: string) => {
  try {
    const token = localStorage.getItem("token");
    const args = {
      url: `locations${queryString ? `?${queryString}` : ''}`,
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    };
    const response = await request(args);
    return response;
  } catch (error: any) {
    toast.error(error.message || "Failed to fetch locations");
    return error;
  }
};

// Get single location
export const getLocation = async (id: number) => {
  try {
    const token = localStorage.getItem("token");
    const args = {
      url: `locations/${id}`,
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    };
    const response = await request(args);
    return response;
  } catch (error: any) {
    toast.error(error.message || "Failed to fetch location");
    return error;
  }
};

// Create new location
export const createLocation = async (data: any) => {
  try {
    const token = localStorage.getItem("token");
    const args = {
      url: "locations",
      method: "POST",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    };
    const response = await request(args);
    if (response.success) {
      toast.success(response.message || "Location created successfully");
    }
    return response;
  } catch (error: any) {
    toast.error(error.message || "Failed to create location");
    return error;
  }
};

// Update location
export const updateLocation = async (id: number, data: any) => {
  try {
    const token = localStorage.getItem("token");
    const args = {
      url: `locations/${id}`,
      method: "PUT",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    };
    const response = await request(args);
    if (response.success) {
      toast.success(response.message || "Location updated successfully");
    }
    return response;
  } catch (error: any) {
    toast.error(error.message || "Failed to update location");
    return error;
  }
};

// Delete location
export const deleteLocation = async (id: number) => {
  try {
    const token = localStorage.getItem("token");
    const args = {
      url: `locations/${id}`,
      method: "DELETE",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    };
    const response = await request(args);
    if (response.success) {
      toast.success(response.message || "Location deleted successfully");
    }
    return response;
  } catch (error: any) {
    toast.error(error.message || "Failed to delete location");
    return error;
  }
};